import { Component, OnInit } from '@angular/core';
import { ROUTES } from './sidebar-routes.config';
import { MenuType } from './sidebar.metadata';
import { SelectorMatcher } from '@angular/compiler';

@Component({
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    isCollapsed = true;
    link1: String;
    link2:String;
    link3:String;

    constructor() {}
    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem.menuType !== MenuType.BRAND);

        console.log(this.menuItems);
        this.languageSelector();
    }
    public get menuIcon(): string {
        return this.isCollapsed ? '☰' : '✖';
    }
    public getMenuItemClasses(menuItem: any) {
        return {
            'pull-xs-right': this.isCollapsed && menuItem.menuType === MenuType.RIGHT
        };
    }

    languageSelector(){
        let lang = localStorage.getItem('language');
        this.link3 = "Quick Search";
        if(lang == "S"){
          this.link1 = "කැල්ක්යුලේටරය";
          this.link2 = "පරිශීලක පැතිකඩ";
        }else if(lang =="T"){
          this.link1 = "கால்குலேட்டர்";
          this.link2 = "பயனர் சுயவிவரம்ு";
        }else{
          this.link1 = "Calculator";
          this.link2 = "User Profile";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts